import * as React from 'react';
import { Box, Label, LabelProps } from '@apia/theme';
import { useAppSelector } from '../../../hooks/hooks';
import useContext from '../../../hooks/useContext';
import { IFieldDefinition } from '../../../types';
import { FieldErrorMsg } from '../../apia/execution/common';
import { ValidationContext } from './ValidationContext';
import RequiredBox from '../../apia/execution/common/RequiredBox';

export interface IWrapper extends LabelProps {
  children: React.ReactNode;
  label: string;
  tooltip: string;
  name: string;
  validations?: IFieldDefinition['validate'];
}

const Wrapper = ({
  children,
  label,
  tooltip,
  validations,
  name,
  ...props
}: IWrapper) => {
  const { form } = useContext(ValidationContext);
  const errors = useAppSelector(
    (global) => global.previousValidationSlice.forms[form]?.errors,
  );

  return (
    <Label
      aria-label={label}
      title={tooltip}
      className={`${validations?.required ? 'required' : ''} ${
        (props.className as string) ?? ''
      }`}
      {...props}
    >
      <Box as="span">
        <RequiredBox
          label={label}
          required={validations?.required}
          avoidColon={false}
        />
      </Box>

      {children}
      {errors && errors[name] && <FieldErrorMsg>{errors[name]}</FieldErrorMsg>}
    </Label>
  );
};

export default Wrapper;
